const Competicao = [

  {
    title: "II CONCURSO DE FOTOGRAFIA DA ESCOLA POLITÉCNICA E DE ARTES",
  instructor: "Luciana Casaletti, Frederico André Rabelo e Genilda da Silva Alexandria Sousa.",
  institution: "PUC Goiás",
  desc: `II Concurso de Fotografia da Escola Politécnica da Universidade Católica de Goiás (PUC Goiás) tem como objetivo fomentar a produção de imagens relacionadas ao tema Fraternidade e Amizade Social e contribuir para a integração dos cursos ofertados pela Escola, bem como o desenvolvimento da cultura e arte entre a comunidade acadêmica.
  <br>
  <br><b>Vencedores:</b>
  <br>
  <br>TERCEIRO LUGAR
  <br>14% dos votos
  <br>
  <br>Título: Floresça por onde FLOR  
  <br>
  <br>Geovanna de Melo Dias França 
  <br>
  <br>Curso: Agronomia 
  <br>
  <br><img src="/assets/GEOVANNA.jpeg" style="max-width: 70%; height: auto;">
  <br>
  <br>SEGUNDO LUGAR
  <br>24% dos votos
  <br>
  <br>Título: Unidos para Superar Desafios  
  <br>
  <br>Moisés Lopes de Matos
  <br>
  <br>Curso: Análise e Desenvolvimento de Sistemas 
  <br>
  <br><img src="/assets/MOISES_LOPES.jpg" style="max-width: 70%; height: auto;">
  <br>
  <br>PRIMEIRO LUGAR
  <br>27% dos votos
  <br>
  <br>Título: Solidariedade 
  <br>
  <br>Salmen Chaquip Bukzem
  <br>
  <br>Curso: Ciências Aeronáuticas
  <br>
  <br><img src="/assets/SALMEN.jpg" style="max-width: 70%; height: auto;">
  <br>
  <br>JORNADA DA CIDADANIA - 2024
  <br>27,3% do votos
  <br>
  <br>TÍTULO: Ambientes propícios às amizades sociais 
  <br>
  <br>Ary Rodrigues de Bessa
  <br>
  <br><img src="/assets/ARY_RODRIGUES.jpeg" style="max-width: 70%; height: auto;">
  `,
  editais:"/assets/Edital Fotografia JCPOLI 2024.pdf",
  date: "18/04",
  time: "19:00",
  place: "Auditório 2, área II",
  /*image: "assets/img/slider/fotografia_2024.jpg",*/
  },

  {
    title: "I DESAFIO EM OTIMIZAÇÃO COM METAHEURÍSTICA",
  instructor: "Maria Jose Pereira Dantas, Alexandre Ribeiro e Lucas Gabriel Godoi Arriel",
  institution: "PUC Goiás",
  desc: `
  <br>Este edital propõe um desafio que envolve a resolução do Problema do Caixeiro Viajante (PCV) utilizando técnicas de otimização com metaheurísticas (MH). É particularmente benéfico para os estudantes nos primeiros estágios de seus cursos universitários engajarem-se neste desafio, pois oferece uma oportunidade significativa para explorar áreas de otimização e metaheurísticas, ampliando seus conhecimentos e contribuindo com novas ideias e perspectivas inovadoras. A participação neste desafio serve como um primeiro passo inspirador na jornada científica de um estudante, proporcionando uma chance única de adquirir experiência prática, interagir com colegas mais experientes e especialistas na área, e desenvolver competências valiosas para toda a carreira acadêmica e profissional.
  <br>
  <br><b>Cronograma</b>
  <br>Lançamento do Edital: 20/04/2024
  <br>Inscrições: 20 a 23/04
  <br>Entrega dos relatórios e código-fonte: 03/05
  <br>Apresentações: 12/05/2024, até 23:59 (link será disponibilizada na sala)
  <br>Anúncio dos Resultados: Publicação na sala do I Desafio até 17/05, 23:59. Na sala do I desafio
  <br>Entrega da Premiação: 19/05/2024, 9h, auditório a ser definido na área 2
  <br>
  <br><a href="https://teams.microsoft.com/l/team/19%3AJ68wGPL0m1e4eqLfKVcYlVAfer1pZA37KR9_tNHC6oA1%40thread.tacv2/conversations?groupId=a772127e-a579-459a-8848-08e216113da1&tenantId=73319f42-8908-4b89-9f8d-558cf4d5d776">Sala Teams do desafio</a>
  <br><a href="https://chat.whatsapp.com/DtOSY0uaQAZ06tCVTGXCmZ">Grupo WhatsApp do desafio</a>
  `,
  editais:"/assets/edital_Idesafio_Otimização.pdf",
  vencedor:"/assets/I-DESAFIO_EM_OTIMIZAÇÃO_COM_METAHEURISTICA_RESULTADO.pdf",
  date: "20/04 a 19/05",
  place: "Teams",
  image: "assets/img/slider/logo-maratona.jpeg"
  },

  {
    title: "VI DESAFIO EM CIÊNCIA DE DADOS",
  instructor: "Maria José Pereira Dantas, José Elmo de Menezes.",
  institution: "PUC Goiás",
  desc: `
  <b>1.	Palestra "Sistema de Gerenciamento de Segurança Operacional" </b>
  <br>Salmen Chaquip Bukzem
  <br>Título: Sistema de Gerenciamento de Segurança Operacional.
  <br>Resumo: Abordagem sistêmica do tema. Considerações sobre os aspectos que envolvem a segurança na operação de uma aeronave.  Promoção e melhoria contínua dos níveis de segurança operacional. Panorama e classificação das ocorrências dos últimos 10 anos. Fatores contribuintes.
  <br>Data: 17/04, 18 às 19h
  <br>Local: <a href="https://teams.microsoft.com/l/meetup-join/19%3adcb5856375ad4247a353459a1d1f6306%40thread.tacv2/1712942235349?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%2272de42cb-2066-4981-b6e6-af2344b756bd%22%7d">Link da sala do Teams</a>
  <br>
  <br><b>2.	Curso introdutório de análise de dados com Linguagem R </b>
  <br>Data: 17/04/2024
  <br>Horário: 20:00-22:00
  <br>Local: <a href="https://teams.microsoft.com/l/team/19%3aHcrIGbRxMtaHnfgMUryabS_UEfdjPkoLxnMLYskgZ3k1%40thread.tacv2/conversations?groupId=9eb3658f-e5d0-4b9a-afcf-dcfbf5a8d97e&tenantId=73319f42-8908-4b89-9f8d-558cf4d5d776">Link da sala do Teams</a>
  <br>
  <br> <b>3.Palestra de abertura do VI Desafio em Ciências de Dados</b>
  <br>Dr. Aníbal Tavares de Azevedo.
  <br>Título: Oportunidades e Desafios na era da Inteligência Artificial massificada.
  <br>Resumo: Nessa conversa serão apontados alguns desenvolvimentos da inteligência
artificial massificada em diversos campos. Diversas aplicações práticas serão abordadas
e exemplificadas. Possibilidades de novos negócios para resolver as
dores do mundo combinando o uso das tecnologias habilitadoras da indústria 4.0 em
conjunto com a inteligência artificial
serão discutidas.
<br>Data: 18/04, 20 às 21h
<br>Local: <a href="https://teams.microsoft.com/l/team/19%3aHcrIGbRxMtaHnfgMUryabS_UEfdjPkoLxnMLYskgZ3k1%40thread.tacv2/conversations?groupId=9eb3658f-e5d0-4b9a-afcf-dcfbf5a8d97e&tenantId=73319f42-8908-4b89-9f8d-558cf4d5d776">Link da sala do Teams</a>
<br>
<br><b>4.	Palestra "Entendendo a Inteligência Artificial Generativa e Seu Impacto no Futuro" </b>
<br>Salatiel Abrão (Ciência da Computação)
<br>Título: Entendendo a Inteligência Artificial Generativa e Seu Impacto no Futuro
<br>Resumo:A inteligência artificial tem se desenvolvido rapidamente nos últimos anos, 
trazendo consigo uma revolução em termos de capacidade generativa. Como uma inteligência artificial consegue criar imagens, 
vídeos e áudios realistas? Além disso, surgem questões importantes como o impacto dos deepfakes na imagem pessoal. 
Recentemente, também se observa avanços significativos na capacidade da IA de processar grandes volumes de texto e gerar recomendações concisas. 
Esse recurso é especialmente valioso em ambientes corporativos e decisórios, onde a rápida análise e síntese de informações podem ser cruciais. 
O que o futuro reserva? Como ficarão os empregos diante dessas mudanças.
<br>Data: 19/04/2024
<br>Horário: 19:00-20:00
<br>Local: <a href="https://teams.microsoft.com/l/team/19%3aHcrIGbRxMtaHnfgMUryabS_UEfdjPkoLxnMLYskgZ3k1%40thread.tacv2/conversations?groupId=9eb3658f-e5d0-4b9a-afcf-dcfbf5a8d97e&tenantId=73319f42-8908-4b89-9f8d-558cf4d5d776">Link da sala do Teams</a>
<br>
<br><b>5.Palestra "Por que somos minoria em STEM?"</b>
<br>Marta Pereira da Luz
<br>Título: Por que somos minoria em STEM?
<br>Resumo: Na palestra será tratado sobre a realidade do mercado de trabalho e sobre a
participação de mulheres em áreas de STEM e será discutido sobre as questões
históricas da mulher nestes cenários.
<br>Data: 19/04, 21 às 22h
<br>Local: <a href="https://teams.microsoft.com/l/team/19%3aHcrIGbRxMtaHnfgMUryabS_UEfdjPkoLxnMLYskgZ3k1%40thread.tacv2/conversations?groupId=9eb3658f-e5d0-4b9a-afcf-dcfbf5a8d97e&tenantId=73319f42-8908-4b89-9f8d-558cf4d5d776">Link da sala do Teams</a>
<br>
<br><b>6.	Curso introdutório de análise da dados com Linguagem Pyhton </b>
<br>Data: 19/04/2024
<br>Horário: 21:00-22:00
<br>Local: <a href="https://teams.microsoft.com/l/team/19%3aHcrIGbRxMtaHnfgMUryabS_UEfdjPkoLxnMLYskgZ3k1%40thread.tacv2/conversations?groupId=9eb3658f-e5d0-4b9a-afcf-dcfbf5a8d97e&tenantId=73319f42-8908-4b89-9f8d-558cf4d5d776">Link da sala do Teams</a>
<br>
<br><a href="https://forms.office.com/r/F7w9cbRKbD">Link de inscrição, prazo de 8/4 a 18/4</a>
`,
  //inscrevase:"https://forms.office.com/r/F7w9cbRKbD",
  vencedor:"/assets/VI_Desafio_em_Ciência_de_Dados_2024_SEGURANÇA_NA_AVIAÇÃO_RESULTADO.pdf",
  datainscri:"08/04 a 18/04/2024",
  date: "17/04 a 19/04",
  time: "20 às 22h",
  place: "Teams",
  image: "assets/img/slider/logo-maratona.jpeg"
  },

  /*
  {
    title: "Maratona de Programação - Primeiro Período",
  instructor: "Alexandre Ribeiro, José Luiz e Olegário",
  institution: "PUC Goiás",
  desc: `Com o objetivo de motivar os estudantes da PUC Goiás a expandirem sua capacidade de resolver problemas, utilizando programação de computadores e desenvolverem a habilidade de trabalhar em grupo, a Maratona de Programação da Escola Politécnica e de Artes será realizada como parte integrante da II JCPOLI.
  `,
  date: "13/05",
  time: "08:30 - 12:15",
  place: "Lab. 101C a 105C, área II",
  image: "assets/img/slider/logo-maratona.jpeg"
  },

  {
    title: "IV DESAFIO EM CIÊNCIA DE DADOS",
  instructor: "Maria José Pereira Dantas. e José Elmo de Menezes.",
  institution: "PUC Goiás",
  desc: `Os participantes enfrentam questões de pesquisa que
  requerem a aplicação de técnicas de Estatística e aprendizado de máquina (machine
  learning). Eles devem utilizar seus conhecimentos teóricos e habilidades práticas
  para analisar uma base de dados pública e encontrar soluções criativas e eficientes
  para os problemas propostos.
    Além de promover a troca de experiências entre os participantes, o desafio
  busca incentivar o desenvolvimento de competências essenciais na área de ciência
  de dados, como análise estatística, modelagem de dados, interpretação de
  resultados e comunicação dos achados.`,
  inscrevase:"https://forms.office.com/r/0YEy9CJ567",
  datainscri:"08/05 (início às 09:00h) e 09/05(até às 23:59h)",
  editais: "/assets/Edital-DESAFIO-CIÊNCIA DOS DADOS-VF-2023-0305.pdf",
  vencedor:"/assets/ivcienciasdados.pdf",
  date: "",
  time: "",
  place: "",
  image: "assets/img/slider/logo-maratona.jpeg"
  },

  {
    title: "I CodeCraft: A Maratona de Desenvolvimento de Sistemas",
  instructor: "Lucília Gomes Ribeiro. e Solange da Silva",
  institution: "PUC Goiás",
  desc: "O CodeCraft é uma maratona de programação (hackathon) que busca estimular a criatividade e o desenvolvimento de soluções tecnológicas inovadoras em um ambiente de competição saudável e colaborativo. O objetivo principal é desafiar os participantes a colocarem em prática suas habilidades criativas, em programação, análise e desenvolvimento de sistemas, com foco em encontrar soluções que possam contribuir para resolver problemas reais e relevantes do cotidiano\n Dia 08:\n 19h às 20h30 - Abertura da Hackathon Como construir um pitch matador (Patrick)\n 20h30 às 22h - Palestra Como soft skills podem lhe garantir uma vaga ou salvar o seu emprego (Camilla)\n Dia 09:\n 17h às 18h30 - Assistir a palestra do youtube IARA: Centro de Pesquisa Aplicada em Inteligência Artificial para Cidades Inteligentes(André Carlos)\n 19h às 20h30 - Assistir a palestra pelo Teams Cidades Inteligentes e Sustentáveis: Ferramentas e Desafios(Raphael)\n 20h30 às 22h - Palestra TI: Caminhos e oportunidades dentro de um mar de possibilidades(Patrick)\n Dia 10:\n 17h às 19h - Oficina de GitHub (Milton) - LAB 101C\n 19h às 21h - HACKATHON\n 21h às 22h - Apresentação dos Pitchs\n Observação: todas as atividades, com exceção da HACKATHON, é aberta ao público.".replace(/\n/g, "<br>"),
  inscrevase:"https://teams.microsoft.com/l/entity/81fef3a6-72aa-4648-a763-de824aeafb7d/_djb2_msteams_prefix_2939677700?context=%7B%22subEntityId%22%3Anull%2C%22channelId%22%3A%2219%3AO38fAS1tDiX3-WkCufiNboPCD32x8lSh2Ae2m9lS3og1%40thread.tacv2%22%7D&groupId=19da8e1f-0199-4600-8d69-d7a4dbd51135&tenantId=73319f42-8908-4b89-9f8d-558cf4d5d776&allowXTenantAccess=false",
  datainscri:"05/05 (início às 09:00h) e 09/05(até às 23:59h)",
  editais:"/assets/Edital-CodeCraft-2023-1.pdf",
  date: " 08 a 10/05/2023",
  time: "A partir de 18:45",
  place: "Auditório 1 (Área II) e Laboratórios 101 a 105C (somente no dia 10/05, das 18h45 às 22h)",
  image: "assets/img/slider/codecraft.jpg"
  },

  {
    title: "Desafio Produtivo",
    instructor: "Santiago Meireles Rocha e Luciana Casaletti",
    institution: "PUC Goiás",
    desc: `Será proposto um desafio para equipes, onde cada uma será responsável por analisar uma das empresas indicadas e defender sua aquisição por parte dos investidores.`,
    image: "assets/img/slider/DesafioProdutivo.jpg",
    date: "10/05",
    time: "09:00-12:15",
    place: "Sala 211, bloco F, área III",
  },

  {
    title: "I Concurso de Fotografia da Escola Politécnica e de Artes",
    instructor: "LUCIANA CASALETTI e GENILDA DA SILVA ALEXANDRIA SOUSA",
    institution: "PUC Goiás",
    desc: `I Concurso de Fotografia da Escola Politécnica e de Artes tem como objetivo fomentar a produção de imagens relacionadas ao tema Escola Politécnica e de Artes: 
    o que nos une, e contribuir para a integração dos cursos da Escola Politécnica e de Artes da Universidade Católica de Goiás, bem como, com o desenvolvimento da cultura 
    e arte entre a comunidade acadêmica.`,
    inscrevase:"https://forms.office.com/r/tmZtXUnWB0",
    datainscri: "24 de abril a 14 de maio de 2023",
    comissjulgadora:"/assets/julgadora.pdf",
    editprorog:"/assets/prorog.pdf",
    editais:"/assets/Concurso_Artes.pdf",
    image: "assets/img/slider/expo_foto.jpg",
    date: "",
    vencedor:"/assets/premiofotografia.pdf",
    place: "Hall Área 2 PUC",
  },
*/
]


export const Competicoes = [
  {
    competicoes: Competicao,
  },
]
